import PasswordResetRequest from "../domain/PasswordResetRequest";
import WsService from "./WsService";

const ENDPOINT_BASE = "/authentication";

export default class PasswordResetService {

    static resetPassword(phoneNumber) {

        let endpoint = ENDPOINT_BASE + "/reset-password";

        let resetRequest = PasswordResetRequest.toJson(phoneNumber);
        let headers = {
            "Authorization" : ""
        };

        return WsService.postWithHeaders(endpoint, resetRequest, 200, headers).then(
            response => {
                return 'success';
            },
            response => {
                return response;
            }
        )
    }

    static changePassword(username, oldPassword, newPassword) {

        let endpoint = ENDPOINT_BASE + "/change-password";

        let jsonObj = {};
        jsonObj["username"] = username;
        jsonObj["old-password"] = oldPassword;
        jsonObj["new-password"] = newPassword;

        return WsService.put(endpoint, jsonObj, 200).then(
            response => {
                return "success";
            },
            response => {
                return response;
            });
    }

}